import { SearchResultsSectionDS } from '@src/components/blocks/search-results-section-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { SearchResultsSectionLegacy, type SearchResultsSectionLegacyProps } from './search-results-section-legacy'

type SearchResultsSectionProps = SearchResultsSectionLegacyProps

function SearchResultsSection(props: SearchResultsSectionProps) {
  if (shouldUseDesignSystem()) {
    return <SearchResultsSectionDS {...props} />
  }
  return <SearchResultsSectionLegacy {...props} />
}

export default SearchResultsSection
